/**
 * Shared between the web app (web_myplann) and the React Native host (app_myplann).
 * The neutral ramp both design systems build on — the page background the WebView
 * and its host have to agree on is grey[50].
 */

export type GreyScale = {
	50: string;
	100: string;
	200: string;
	300: string;
	400: string;
	500: string;
	600: string;
	700: string;
	800: string;
	900: string;
};

export const greyScale: GreyScale = {
	50: "#FAFAFA",
	100: "#F5F5F5",
	200: "#E5E5E5",
	300: "#D4D4D4",
	400: "#A3A3A3",
	500: "#737373",
	600: "#525252",
	700: "#404040",
	800: "#262626",
	900: "#171717",
};

export const darkGreyScale: GreyScale = {
	50: "#1B1B1E",
	100: "#242427",
	200: "#303034",
	300: "#3D3D42",
	400: "#8C8C93",
	500: "#95959B",
	600: "#AFAFB5",
	700: "#C7C7CC",
	800: "#E1E1E4",
	900: "#F4F4F6",
};
